module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('section', {
    staticClass: "cabinet section_pad"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('aside', {
    staticClass: "sidebar layout__sidebar"
  }, [_c('div', {
    staticClass: "sidebar__avatar-wrap"
  }, [_c('user-avatar', {
    attrs: {
      "data": _vm.user,
      "setClass": 'sidebar__avatar user_fix'
    }
  })], 1), _vm._v(" "), _c('nav', {
    staticClass: "sidebar__menu"
  }, [_c('ul', {
    staticClass: "sidebar__list"
  }, [_c('li', {
    staticClass: "sidebar__list-item"
  }, [_c('router-link', {
    staticClass: "sidebar__link",
    attrs: {
      "to": {
        name: 'Events'
      }
    }
  }, [_vm._v(" - Мои события")])], 1), _vm._v(" "), _c('li', {
    staticClass: "sidebar__list-item"
  }, [_c('router-link', {
    staticClass: "sidebar__link",
    attrs: {
      "to": {
        name: 'Visits'
      }
    }
  }, [_vm._v(" - Визиты")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__box"
  }, [_c('router-view')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc379d0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cabinet/Cabinet/Main.vue
// module id = 651
// module chunks = 0